import React from 'react';

interface ClassbookIconProps {
  className?: string;
  style?: React.CSSProperties;
  /** Rendered width/height in px. */
  size?: number;
}

/**
 * Classbook icon in Fluent v9 Filled style.
 *
 * Used to represent the digital classbook (Klassenbuch) module, e.g. in
 * navigation tiles and module headers. The artwork is a closed book/binder
 * with a bookmark ribbon in the upper-left corner — adapted from the
 * Material Icons `class` glyph into the Fluent v9 visual language (20×20
 * viewBox, 2px corner radius, single filled path).
 *
 * The bookmark is cut out via the `evenodd` fill rule so the icon picks
 * up `currentColor` cleanly with no overlay artifacts.
 */
export const ClassbookIcon: React.FC<ClassbookIconProps> = ({ className, style, size = 20 }) => (
  <svg
    role="presentation"
    focusable="false"
    aria-hidden="true"
    viewBox="0 0 20 20"
    width={size}
    height={size}
    fill="currentColor"
    className={className}
    style={style}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6 2A2 2 0 0 0 4 4v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2H6Zm0 2h4v7l-2-1.5L6 11V4Z"
    />
  </svg>
);
